import { createStore } from 'vuex';

import { storeGlobalConfig } from '@/services/vuex-global-config.js';

import actions from './actions.js';
import getters from './getters.js';
import mutations from './mutations.js';
import state from './state.js';

export const storeConfig = {
  state,
  getters,
  mutations,
  actions,
};

export default new createStore({
  ...storeGlobalConfig,
  ...storeConfig,
});
